import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

// Firebase imports
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { environment } from '../environments/environment';

// Modulos Personalizados
import { AppRoutingModule } from './app-routing.module';
import { PagesModule } from './pages/pages.module';
import { AuthModule } from './auth/auth.module';
import { AppComponent } from './app.component';
import { NopagefoundComponent } from './404/nopagefound.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { LayoutModule } from './layout/layout.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { DirectivesModule } from './directives/directives.module';
import { WidgetsModule } from './shared/widgets.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TimezoneInterceptor } from './interceptors/timezone.interceptor';
import { AuthTokenInterceptor } from './interceptors/auth-token.interceptor';
import { AuthExpiredInterceptor } from './interceptors/auth-expired.interceptor';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav'; // Import the module
@NgModule({
  declarations: [
    AppComponent,
    NopagefoundComponent
  ],
  imports: [
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule, // modulo de rutas personalizada
    LayoutModule,
    PagesModule, // modulo de paginas
    AuthModule, // modulo de login y registro
    NgbModule,
    MatDialogModule,
    MatTabsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    DirectivesModule,
    WidgetsModule,
    WjNavModule
    //AngularSignaturePadModule.forRoot()
  ],
  providers: [
    // Firebase providers
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideMessaging(() => getMessaging()),
    provideNgxMask(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthTokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimezoneInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthExpiredInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
